var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnicalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 47,
    viewBox: "0 0 41 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1747 4.82694L41 0.037048V28.4829C41 32.3858 40.1673 35.7187 38.502 38.4815C36.8589 41.2442 34.472 43.3602 31.3412 44.8293C28.2104 46.2764 24.4246 47 19.9838 47C15.6761 47 12.0347 46.3093 9.0593 44.9279C6.08394 43.5246 3.83022 41.4854 2.29813 38.8104C0.766044 36.1134 0 32.8353 0 28.9762V0H9.82535V28.2197C9.82535 31.8815 10.7024 34.6662 12.4565 36.5738C14.2329 38.4595 16.8308 39.4024 20.2502 39.4024C23.7585 39.4024 26.4563 38.4157 28.3436 36.4423C30.231 34.4469 31.1747 31.5965 31.1747 27.8908V4.82694Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6378 10.9412L13.6671 13.3644V10.5576H13.6641V26.74C13.6641 28.9575 14.1287 30.8511 15.058 32.4207C15.9007 33.8633 17.0939 34.9955 18.6378 35.8172V10.9412Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1855 9.20889L27.1593 6.78418V10.5578V11.9613V26.7402C27.1593 28.9577 26.6946 30.8513 25.7653 32.4209C24.9227 33.8635 23.7294 34.9957 22.1855 35.8174V11.9613V10.5578V9.20889Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicalLogo);
export default __webpack_public_path__ + "static/media/unicalLogo.9286733d36c562929015b26c57d24487.svg";
export { ForwardRef as ReactComponent };